import React from 'react'
import { shallow } from 'enzyme'
import { EditProduct } from '../features/product/EditProduct'

describe('<EditProduct />', () => {
  let wrapper, props, instance, e
  beforeEach(() => {
    props = {
      productSwitchReasons: [],
      loan: {
        hardCreditPulled: false,
        amount: 100000,
        product: {
          name: 'test product',
          lenderKey: 'tab'
        }
      },
      product: {
        name: 'test product',
        lenderKey: 'tab'
      },
      products: []
    }
    wrapper = shallow(<EditProduct {...props} />)
    instance = wrapper.instance()
  })
  describe('#onReasonCheck', () => {
    describe('when a reason is checked off', () => {
      beforeEach(() => {
        wrapper = shallow(<EditProduct {...props} />)
        instance = wrapper.instance()
        e = { target: { checked: true, value: 'test' } }
      })
      it('should add the event target\'s value to the list of reasons', () => {
        instance.onReasonCheck(e)
        expect(wrapper.state('reasons')).toContain(e.target.value)
      })
    })
    describe('when a reason is unchecked', () => {
      let checkEvent, uncheckEvent
      beforeEach(() => {
        checkEvent = { target: { checked: true, value: 'test reason' } }
        uncheckEvent = { target: { checked: false, value: 'test reason' } }
        wrapper = shallow(<EditProduct {...props} />)
        wrapper.setState({ reasons: [e.target.value] })
      })
      it('should remove the reason from the list', () => {
        instance.onReasonCheck(checkEvent)
        instance.onReasonCheck(uncheckEvent)
        expect(wrapper.state('reasons')).not.toContain(uncheckEvent.target.value)
      })
    })
  })
  describe('#onNoteChange', () => {
    beforeEach(() => {
      e = { target: { value: 'test' } }
    })
    it('should update the note with the event target\'s value', () => {
      instance.onNoteChange(e)
      expect(wrapper.state('note')).toBe(e.target.value)
    })
  })
  describe('#onProductChange', () => {
    beforeEach(() => {
      props = {
        ...props,
        products: [
          { name: 'test product 1' },
          { name: 'test product 2' }
        ],
        product: { name: 'test product 1' }
      }
      e = { target: { value: props.products[1].name } }
      wrapper = shallow(<EditProduct {...props} />)
      instance = wrapper.instance()
    })
    it('should update selectedProduct to the provided product', () => {
      instance.onProductChange(e)
      expect(wrapper.state('selectedProduct').name).toBe(e.target.value)
    })
  })
  describe('#isNoteValid', () => {
    describe('when a note is required and there is no note entered', () => {
      beforeEach(() => {
        wrapper = shallow(<EditProduct {...props} />)
        instance = wrapper.instance()
      })
      it('should return false', () => {

      })
    })
    describe('when a note is required and there is a note entered', () => {
      it('should return true', () => {
        expect(instance.isNoteValid(['other'], 'test note')).toBeTruthy()
      })
    })
  })
  describe('#isProductValidForLoanAmount', () => {
    beforeEach(() => {
      wrapper = shallow(<EditProduct {...props} />)
      instance = wrapper.instance()
    })
    describe('when the product is valid', () => {
      it('should return true', () => {
        const product = {
          manualMin: 50000,
          manualMax: 150000
        }
        const amount = 100000
        expect(instance.isProductValidForLoanAmount({ product, amount })).toBeTruthy()
      })
    })
    describe('when the loan amount is less than what the product allows', () => {
      it('should return false', () => {
        const product = {
          manualMin: 50000,
          manualMax: 150000
        }
        const amount = 180000
        expect(instance.isProductValidForLoanAmount({ product, amount })).toBeFalsy()
      })
    })
    describe('when the loan amount is greater than what the product allows', () => {
      it('should return false', () => {
        const product = {
          manualMin: 50000,
          manualMax: 150000
        }
        const amount = 10000
        expect(instance.isProductValidForLoanAmount({ product, amount })).toBeFalsy()
      })
    })
  })
  describe('#isValid', () => {
    beforeEach(() => {
      wrapper.setState({
        selectedProduct: { manualMin: 50000, manualMax: 150000, name: 'Test 1' }
      })
    })
    describe('when no reason is selected', () => {
      it('should return false', () => {
        expect(instance.isValid()).toBeFalsy()
      })
    })
    describe('when a reason with a required note is selected and there is no note entered', () => {
      beforeEach(() => {
        wrapper.setState({ reasons: ['other'] })
      })
      it('should return false', () => {
        expect(instance.isValid()).toBeFalsy()
      })
    })
    describe('when the loan amount is incompatible with the selectedProduct', () => {
      beforeEach(() => {
        wrapper.setState({ product: { manualMin: 0, manualMax: 10000 } })
      })
      it('should return false', () => {
        expect(instance.isValid()).toBeFalsy()
      })
    })
    describe('when a reason with a required note is selected and there is a note entered', () => {
      beforeEach(() => {
        wrapper.setState({
          reasons: ['Others - Additional notes required if this is selected'],
          note: 'test'
        })
      })
      it('should return true', () => {
        expect(instance.isValid()).toBeTruthy()
      })
    })
    describe('when the loan has a hard-pull', () => {
      it('should be true', () => {
        props.loan.hardCreditPulled = true
        wrapper.setProps({ props })
        expect(instance.isValid()).toBeFalsy()
      })
    })
  })
  describe('#isNoteRequired', () => {
    describe('when "other" is one of the selected reasons', () => {
      it('should return true', () => {
        expect(instance.isNoteRequired(['other'])).toBe(true)
      })
    })
    describe('when "other" is not one of the selected reasons', () => {
      it('should return false', () => {
        expect(instance.isNoteRequired([])).toBe(false)
      })
    })
  })
  describe('#isLenderSame', () => {
    describe('when both products are from same lender', () => {
      it('should return true', () => {
        const isLenderSame = instance.isLenderSame(props.loan.product.lenderKey, props.product.lenderKey)
        expect(isLenderSame).toBe(true)
      })
    })
    describe('when both products are not from same lender', () => {
      it('should return false', () => {
        props.loan.product.lenderKey = 'five_star'
        wrapper.setProps({ props })
        const isLenderSame = instance.isLenderSame(props.loan.product.lenderKey, props.product.lenderKey)
        expect(isLenderSame).toBe(false)
      })
    })
  })
  describe('#isCreditPullValidForProductChange', () => {
    let hardCreditPulled, customerService, isLenderSame
    beforeEach(() => {
      hardCreditPulled = true
      customerService = true
      isLenderSame = true
    })
    describe('when hard credit pulled', () => {
      it('should return true', () => {
        const isValid = instance.isCreditPullValidForProductChange(hardCreditPulled, customerService, isLenderSame)
        expect(isValid).toBeTruthy
      })
      describe('when not customerService', () => {
        beforeEach(() => {
          customerService = false
        })
        it('should return true', () => {
          const isValid = instance.isCreditPullValidForProductChange(hardCreditPulled, customerService, isLenderSame)
          expect(isValid).toBeFalsy
        })
      })
      describe('when lenders are different', () => {
        beforeEach(() => {
          isLenderSame = false
        })
        it('should return true', () => {
          const isValid = instance.isCreditPullValidForProductChange(hardCreditPulled, customerService, isLenderSame)
          expect(isValid).toBeFalsy
        })
      })
    })
    describe('when not hard credit pulled', () => {
      beforeEach(() => {
          hardCreditPulled = false
        })
      it('should return true', () => {
        const isValid = instance.isCreditPullValidForProductChange(hardCreditPulled, customerService, isLenderSame)
        expect(isValid).toBeTruthy
      })
    })
  })
})
